import { Component, Input } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ContentService } from './services/content.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(private contentService: ContentService, private titleService: Title) {
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.contentService.getTitle());
  }

}
